export default {
  header: {
    back: '返回',
    title: '更改密码'
  },
  label: {
    resetPay: '修改支付密码',
    resetPass: '修改登陆密码',
    oldPasswd: '旧密码',
    newPasswd: '新密码',
    reNewPasswd: '确认新密码',
    bindgoogle: 'google验证器'
  },
  placeholder: {
    oldPasswd: '请输入旧密码',
    newPasswd: '请输入新密码',
    reNewPasswd: '请再次输入新密码',
    bindgoogle: '请输入google验证器'
  },
  rules: {
    oldPasswd: {
      required: '旧密码不能为空！',
      format: '密码格式不正确！'
    },
    newPasswd: { required: '新密码不能为空！', format: '密码格式不正确！' },
    reNewPasswd: {
      required: '确认新密码不能为空！',
      format: '密码格式不正确！',
      same: `新密码和确认新密码必须相同！`
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/passwd.js